import { Environment } from "@react-three/drei";


function StarsEnvironment({ ...props }) {
  return <Environment  files="/images/quarry_04_puresky_1k_red.hdr"  />;
}

export default StarsEnvironment;
